import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

interface DemoStatementsEnabledResponse {
  enabled: boolean;
}

export function useDemoStatementsEnabled(
  corporationId: number | null | undefined
) {
  const id = corporationId != null && corporationId > 0 ? corporationId : null;

  const { data, error, isLoading } = useSWR<DemoStatementsEnabledResponse>(
    id ? `rootfi/demo-statements-enabled?corporationId=${id}` : null,
    SWRFetcher({ method: 'GET' })
  );

  return {
    isDemoStatementsEnabled: data?.enabled ?? false,
    isLoading,
    error,
  };
}
